// extracted by mini-css-extract-plugin
var _1 = "howToPlay";
export { _1 as "howToPlay" }
